import { PAGE_NAME } from '@op/constants/page';
import { createContext } from 'react';

export const FilterPageSourceContext = createContext<{
  excludeSource: Array<{ menu_id: string; source: string }>;
  hidePageIds: Array<string>;
}>({
  excludeSource: [],
  hidePageIds: [],
});

export const FilterPageNameContext = createContext<{
  pageName?: PAGE_NAME;
  menuId?: string;
}>({});
